export default "__VITE_ASSET__78f456be__"